// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"ee06dfcfb86c757f","9651":"12b1427a8c3bc186"}[chunkId] + ".js";
};